/* esm.sh - unist-util-visit-parents@6.0.2 */
export * from "/*unist-util-visit-parents@6.0.2/esnext/unist-util-visit-parents.mjs";
